function About() {
  return (
    <div className="container" style={{minHeight: "85vh"}}>
      <h1>About Us</h1>

      <main style={{textAlign: "left"}}>
        <p>Welcome to the Rubber Ducky Blog, where tech and ducks collide in a beautiful, feathery explosion of knowledge! We're the go-to blog for developers and rubber ducks alike, and we're here to make tech a little bit more fun.</p>

        <p>Our name is a nod to the famous rubber duck debugging method, where devs explain their code to a rubber duck and find the solution to their problem in the process (check out our post on this method!). Who better to explain the world of technology to than our feathered friends?</p>

        <p>Our team of tech-savvy ducks is dedicated to bringing you the most informative and entertaining content, all while keeping things light and fluffy. So if you're looking for a tech blog that's both informative and a little bit silly, look no further.</p>

        <p>Join us on our quest to make the tech world a little bit quackier, and let's debug the world, one duck at a time!</p>
      </main>
    </div>
  );
}

export default About;
